import {SuiModal, ComponentModalConfig, ModalSize} from "ng2-semantic-ui"
import { Component, OnInit, Input } from '@angular/core';
import { IConfirmFormModalContext } from '../models/confirmFormModal.interface';

@Component({
    selector: 'modal-form-confirm',
    template: `
<div class="header">{{ modal.context.title }}</div>
<div class="content">
    <form #modalForm="ngForm" class="ui form error">
        <div class="field">
            <label>{{modal.context.input}}</label>
            <div class="ui input">
                <input type="mail" name="receiver" pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$" ngModel #receiver="ngModel" placeholder="Mail" required>
            </div>
        </div>
        <div *ngIf="modalForm.dirty && !modalForm.valid" class="ui error message">
            <div class="header">{{modal.context.errorTitle}}</div>
            <p>{{modal.context.errorMessage}}</p>
        </div>
    </form>
</div>
<div class="actions">
    <button class="ui red button" (click)="modal.deny(undefined)">Cancel</button>
    <button class="ui green button" [disabled]="!modalForm.valid" (click)="modal.approve(modalForm)" autofocus>OK</button>
</div>
`
})
export class ConfirmFormModalComponent {
    constructor(public modal:SuiModal<IConfirmFormModalContext, void, void>) {}
}
